import { UserState } from './user/state/user.state';
import { DashboardState } from './dashboard/state/dashboard.state';

// Import State slices and add to the rollUp array
// Export array of slices to be declared in app module
export const stateRollUp = [UserState, DashboardState];
export const persistedStateRollUp = ['user.user', 'dashboard.queriedPrograms'];
